import React from "react";

import { snakeToTitle, getPath } from "../utils";
import { labelOverrides } from "../labels";

import Table from "react-bootstrap/Table";

const InfoTable = ({ data, rows, units, extraRows }) => {
  const formatNull = (value) => {
    if (value === null) {
      // Replace with this line to explicitly show when rows are unavailable:
      //return <t className="text-muted">unavailable</t>;
      return value;
    } else {
      return value;
    }
  };

  const formatUndefined = (value) => {
    if (value === undefined) {
      // Replace with this line to explicitly show when rows are unavailable:
      //return <t className="text-muted">unavailable</t>;
      return null;
    } else {
      return value;
    }
  };

  const formatFloat = (value, fieldName) => {
    if (typeof value === "number") {
      let valueStr = Number.isInteger(value) ? value : value.toPrecision(4);
      let unit = getPath([fieldName], units);
      if (unit !== undefined) {
        return valueStr + " " + unit;
      } else {
        return valueStr;
      }
    } else {
      return value;
    }
  };

  const formatBool = (value) => {
    if (typeof value === "boolean") {
      if (value) {
        return "Yes";
      } else {
        return "No";
      }
    } else {
      return value;
    }
  };

  const formatArray = (value) => {
    if (value !== null) {
      if (value.constructor === Array) {
        return value.join(", ");
      } else {
        return value;
      }
    } else {
      return value;
    }
  };

  // Format data for table
  const formatValue = (value, fieldName) => {
    return formatArray(
      formatNull(formatFloat(formatBool(formatUndefined(value)), fieldName)),
    );
  };

  const formatLabel = (fieldName) => {
    if (fieldName in labelOverrides) {
      return labelOverrides[fieldName];
    } else {
      return snakeToTitle(fieldName);
    }
  };

  data = data ? data : null;
  // Get each row of data to be displayed in the table (as strings)
  if (rows != null) {
    var row_values = rows.map(function (row, i) {
      var fieldName = row[row.length - 1];
      var displayValue = "";

      if (data !== null) {
        if (data.length !== 0) {
          displayValue = formatValue(getPath(row, data), fieldName);
        } else {
          displayValue = <div className="text-muted">Loading...</div>;
        }
      } else {
        displayValue = <div className="text-muted">Loading...</div>;
      }
      return [formatLabel(row[row.length - 1]), displayValue];
    });
  } else {
    var row_values = [];
  }

  if (extraRows) {
    extraRows.forEach((extraRow) => {
      row_values.push(extraRow);
    });
  }

  // Filter out missing (null) values
  row_values = row_values.filter((row_value) => row_value[1] !== null);

  // Build table from rows
  var row_components = row_values.map(function (row, i) {
    if (i === 0) {
      var rowStyle = { borderTop: "none" };
    } else if (i === row_values.length - 1) {
      var rowStyle = { borderBottom: "none" };
    }
    return (
      <tr key={i} style={rowStyle} align="left">
        <td>
          <b>{row[0]}</b>
        </td>
        <td>{row[1]}</td>
      </tr>
    );
  });

  // Wrap in Bootstrap Table and return
  return (
    <Table
      bordered
      hover
      style={{ borderRight: "0px solid #FFF", borderLeft: "0px solid #FFF" }}
    >
      <tbody>{row_components}</tbody>
    </Table>
  );
};

export default InfoTable;
